<template>
    <BreadCrumb PageTitle="Liste des types d'emploi du temps" />
    <ListeTypeEmploiDuTemps />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeTypeEmploiDuTemps from "../../components/TypeEmploiDuTemps/ListeTypeEmploiDuTemps.vue";

  
    export default defineComponent({
      name: "ListeTypeEmploiDuTempsPage",
      components: {
        BreadCrumb,
        ListeTypeEmploiDuTemps,
      },
    });
  </script>